import { Alert } from '@rikstv/shared-components';
import type { FC } from 'react';

export const NgtAlertForSummary: FC<{ className?: string }> = ({ className }) => (
  <Alert
    testId="internet-invoice-alert"
    variant="translucent"
    dismissible={false}
    intent="info"
    heading="Internett fra NextGenTel"
    className={className}
  >
    Vi sender bestillingen din for internettet til NextGenTel, og du vil få mer informasjon om internett-pakken din direkte fra NextGenTel.
  </Alert>
);
